import type { ReactNode } from 'react';
import { Tab } from '../Tab/Tab';
import { getTabsClassNames } from './Tabs.styles';
import type { TabsProps } from './Tabs.types';

export const Tabs = <TKey extends string = string>(
  props: TabsProps<TKey>,
): ReactNode => (
  <div className={getTabsClassNames(props.variant, props.className)}>
    {props.tabs.map((tab) => (
      <Tab
        {...tab}
        key={tab.id}
        onSelect={props.onChange}
        selected={props.value === tab.id}
        variant={props.variant}
        onClose={props.onCloseTab}
      />
    ))}
  </div>
);
